/*!
 * Catalyst first-party attribution tracker.
 *
 * Drop this on a Shopify storefront (theme.liquid). On a visit that arrives with
 * a Meta click id (fbclid) or UTM params, it:
 *   1. remembers them in first-party storage (last paid-click wins, 90-day window),
 *   2. writes them onto the cart as hidden (_-prefixed) attributes, so they ride
 *      along to the resulting Shopify order (where we read them back), and
 *   3. (optional) beacons a click event to our backend for the click_events table.
 *
 * Hidden "_" attributes are not shown to the customer but ARE on the order via
 * the Admin API. The Shopify order (customer email) stays the identity anchor.
 *
 * Optional config (set before this script runs):
 *   window.CATALYST_TRACK_URL = "https://your-app.vercel.app/api/track";
 */
(function () {
  "use strict";

  var PARAMS = ["fbclid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  var STORE_KEY = "_catalyst_attr";
  var AID_KEY = "_catalyst_aid";
  var WINDOW_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

  function readUrlParams() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var found = {};
    var has = false;
    for (var i = 0; i < PARAMS.length; i++) {
      var v = qs.get(PARAMS[i]);
      if (v) { found[PARAMS[i]] = v; has = true; }
    }
    return has ? found : null;
  }

  function load() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || "null"); } catch (e) { return null; }
  }
  function save(o) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(o)); } catch (e) {}
  }
  function anonId() {
    try {
      var id = localStorage.getItem(AID_KEY);
      if (!id) {
        id = "a_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem(AID_KEY, id);
      }
      return id;
    } catch (e) { return null; }
  }

  // --- 1. Capture -----------------------------------------------------------
  // Only overwrite stored attribution when THIS visit carries params, so a later
  // organic/direct visit doesn't erase the paid click within the window.
  var fresh = readUrlParams();
  var stored = load();
  if (stored && stored._ts && Date.now() - new Date(stored._ts).getTime() > WINDOW_MS) {
    stored = null; // expired
  }
  if (fresh) {
    fresh._ts = new Date().toISOString();
    fresh.landing_page = window.location.href;
    fresh.referrer = document.referrer || "";
    save(fresh);
    stored = fresh;
  }
  if (!stored) return; // nothing to attribute

  // --- 2. Write hidden cart attributes onto the cart ------------------------
  // Run on every page load: read the current cart and (re)apply our attributes
  // only if missing/changed. This self-heals the empty-cart case — Shopify may
  // not persist attributes until the cart has an item — without spamming.
  function cartAttrs() {
    var a = {};
    for (var i = 0; i < PARAMS.length; i++) {
      if (stored[PARAMS[i]]) a["_" + PARAMS[i]] = stored[PARAMS[i]];
    }
    return a;
  }

  function ensureCartAttrs() {
    var want = cartAttrs();
    if (!Object.keys(want).length) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = (cart && cart.attributes) || {};
        for (var k in want) {
          if (Object.prototype.hasOwnProperty.call(want, k) && cur[k] !== want[k]) {
            return fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ attributes: want }),
            });
          }
        }
      })
      .catch(function () {});
  }

  ensureCartAttrs();

  // Re-apply right after an AJAX add-to-cart (when the cart first gets an item).
  if (window.fetch) {
    var _origFetch = window.fetch;
    window.fetch = function () {
      var p = _origFetch.apply(this, arguments);
      try {
        var arg = arguments[0];
        var u = typeof arg === "string" ? arg : (arg && arg.url) || "";
        if (u.indexOf("/cart/add") !== -1) p.then(function () { setTimeout(ensureCartAttrs, 300); });
      } catch (e) {}
      return p;
    };
  }

  // --- 3. Optional click_events beacon --------------------------------------
  if (fresh && window.CATALYST_TRACK_URL && navigator.sendBeacon) {
    try {
      var payload = {
        shop_domain: (window.Shopify && window.Shopify.shop) || window.location.host,
        anonymous_id: anonId(),
        fbclid: stored.fbclid || null,
        utm_source: stored.utm_source || null,
        utm_medium: stored.utm_medium || null,
        utm_campaign: stored.utm_campaign || null,
        utm_content: stored.utm_content || null,
        utm_term: stored.utm_term || null,
        landing_page: stored.landing_page || window.location.href,
        referrer: stored.referrer || document.referrer || "",
      };
      navigator.sendBeacon(
        window.CATALYST_TRACK_URL,
        new Blob([JSON.stringify(payload)], { type: "text/plain" }),
      );
    } catch (e) {}
  }
})();